import { render } from "./ContainerLayout.vue?vue&type=template&id=3b22160c"
import script from "./ContainerLayout.vue?vue&type=script&lang=js"
export * from "./ContainerLayout.vue?vue&type=script&lang=js"

import exportComponent from "/builds/cloud-game/goc_backstage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__